import classNames from 'classnames';

import { Skeleton } from '@ui/Skeleton';

import s from './ProductDetailsDescription.sss';

interface Props {
  className?: string,
}

export const ProductDetailsDescriptionSkeleton: React.FC<Props> = ({
  className,
}) => {
  return (
    <div className={classNames(s.root, className)}>
      <Skeleton
        width='100px'
        height='20px'
      />
    
      <div className={s.description}>
        <Skeleton
          width='80%'
          height='14px'
        />
        <Skeleton
          width='60%'
          height='14px'
        />
        <Skeleton
          width='50%'
          height='14px'
        />
        <Skeleton
          width='30%'
          height='14px'
        />
      </div>
    </div>
  );
};
